const orgCode = [
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "미래에셋증권 주식회사",
		orgCode: "ZVAACU0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "하나금융투자",
		orgCode: "ZVAAKN0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)핀다",
		orgCode: "ZVAALO0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)우리은행",
		orgCode: "ZVAAEM0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 국민은행",
		orgCode: "ZVAAEO0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)신한은행",
		orgCode: "ZVAAER0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "신한카드 주식회사",
		orgCode: "ZVAAEX0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "비씨카드 주식회사",
		orgCode: "ZVAAFQ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 민앤지",
		orgCode: "ZVAAFY0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 민앤지",
		orgCode: "ZVAAFY0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 핀크(Finnq inc.)",
		orgCode: "ZVAAJI0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "현대캐피탈 주식회사",
		orgCode: "ZVAADE0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "웰컴저축은행",
		orgCode: "ZVAAKU0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "비바리퍼블리카",
		orgCode: "ZVAADV0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 우리카드",
		orgCode: "ZVAAAH0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 한국스탠다드차타드은행",
		orgCode: "ZVAAAK0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "농업협동조합중앙회",
		orgCode: "ZVAAAZ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "에스케이플래닛(주)",
		orgCode: "ZVAABE0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "농협은행 주식회사",
		orgCode: "ZVAABG0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "쿠콘",
		orgCode: "ZVAAKF0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "키움증권",
		orgCode: "ZVAABR0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "코리아크레딧뷰로(주)",
		orgCode: "ZVAAJF0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "KB캐피탈",
		orgCode: "ZVAADZ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 아이지넷",
		orgCode: "ZVAATB0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)엘지씨엔에스",
		orgCode: "ZVAASP0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: ""
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "전북은행",
		orgCode: "ZVAAHP0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: ""
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "유비벨록스(주)",
		orgCode: "ZVAAWH0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)뱅크샐러드",
		orgCode: "ZVAABN0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "케이비증권",
		orgCode: "ZVAADA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "팀윙크",
		orgCode: "ZVAAML0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "보맵 주식회사",
		orgCode: "ZVAAHM0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)광주은행",
		orgCode: "ZVAAMW0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)해빗팩토리",
		orgCode: "ZVAAHQ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "네이버파이낸셜(주)",
		orgCode: "ZVAAHY0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 한국금융솔루션",
		orgCode: "ZVAAIB0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "엔에이치엔페이코 주식회사",
		orgCode: "ZVAAIE0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 한국신용데이터",
		orgCode: "ZVAAIY0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주)카카오페이",
		orgCode: "ZVAAIA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "KB국민카드",
		orgCode: "ZVAAAF0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "하나카드",
		orgCode: "ZVAABJ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "현대카드",
		orgCode: "ZVAAFO0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "한국투자증권 (주)",
		orgCode: "ZVAACT0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 핀테크",
		orgCode: "ZVAAKI0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "(주) 대구은행",
		orgCode: "ZVAAHS0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "뱅큐",
		orgCode: "ZVAAQN0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "중소기업은행",
		orgCode: "ZVAAEQ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "교보생명보험(주)",
		orgCode: "ZVAAAI0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "NH투자증권",
		orgCode: "ZVAACQ0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "주식회사 하나은행",
		orgCode: "ZVAAES0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "나이스평가정보(주)",
		orgCode: "ZVAACW0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "마이데이터사업자",
		industryType: "-",
		orgName: "디셈버앤컴퍼니자산운용",
		orgCode: "ZVAADW0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: ""
	},
	{
		orgType: "지원기관",
		industryType: "-",
		orgName: "한국신용정보원",
		orgCode: "ZZAAAA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "지원기관",
		industryType: "-",
		orgName: "금융보안원",
		orgCode: "ZZAAIR0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "메리츠화재해상보험주식회사",
		orgCode: "B2AACR0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "미래에셋증권 주식회사",
		orgCode: "C1AACU0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "하나금융투자",
		orgCode: "C1AAKN0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "대신증권(주)",
		orgCode: "C1AAKO0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "신영증권",
		orgCode: "C1AAJE0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "한화투자증권",
		orgCode: "C1AACY0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "메리츠증권(주)",
		orgCode: "C1AACZ0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "(주)우리은행",
		orgCode: "A1AAEM0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "디비손해보험 주식회사",
		orgCode: "B2AAEN0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "주식회사 국민은행",
		orgCode: "A1AAEO0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "중소기업은행",
		orgCode: "A1AAEQ0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "중소기업은행",
		orgCode: "D1AAEQ0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "주식회사 신한은행",
		orgCode: "A1AAER0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "주식회사 하나은행",
		orgCode: "A1AAES0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "동양생명보험(주)",
		orgCode: "B1AAEU0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "삼성카드주식회사",
		orgCode: "D1AAEV0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "삼성화재해상보험주식회사",
		orgCode: "B2AAEW0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "신한카드 주식회사",
		orgCode: "D1AAEX0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "신한카드 주식회사",
		orgCode: "D3AAEX0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "비씨카드 주식회사",
		orgCode: "D1AAFQ0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "IBK캐피탈",
		orgCode: "D3AAMG0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "유안타증권 주식회사",
		orgCode: "C1AADC0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "현대차증권",
		orgCode: "C1AADD0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "한화손해보험",
		orgCode: "B2AADH0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "케이비증권 주식회사",
		orgCode: "C1AADA0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "메트라이프생명",
		orgCode: "B1AADN0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "롯데카드 주식회사",
		orgCode: "D1AADO0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "롯데카드 주식회사",
		orgCode: "D3AADO0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "웰컴저축은행",
		orgCode: "A3AAKU0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "케이비캐피탈 주식회사",
		orgCode: "D3AADZ0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "우정사업본부",
		orgCode: "A1AAKA0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "우정사업본부",
		orgCode: "B1AAKA0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "우정사업본부",
		orgCode: "D1AAKA0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "-",
		orgName: "코리아크레딧뷰로(주)",
		orgCode: "M1AAJF0000",
		industry: "tbdindstr",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "KB국민카드",
		orgCode: "D1AAAF0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "KB국민카드",
		orgCode: "D3AAAF0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "흥국화재해상보험(주)",
		orgCode: "B2AANY0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "주식회사 한국스탠다드차타드은행",
		orgCode: "A1AAAK0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "주식회사 한국스탠다드차타드은행",
		orgCode: "D1AAAK0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "흥국생명보험주식회사",
		orgCode: "B1AAAO0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "삼성생명보험",
		orgCode: "B1AAAR0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "신한라이프생명보험 주식회사",
		orgCode: "B1AAAS0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "롯데손해보험주식회사",
		orgCode: "B2AAAT0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "엔에이치농협캐피탈주식회사",
		orgCode: "D3AAOB0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "농협손해보험 주식회사",
		orgCode: "B2AAOC0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "농협은행 주식회사",
		orgCode: "D1AABG0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "농협은행 주식회사",
		orgCode: "A1AABG0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "하나카드 주식회사",
		orgCode: "D1AABJ0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "농협생명보험 주식회사",
		orgCode: "B1AABF0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "이베스트투자증권(주)",
		orgCode: "C1AABQ0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "전자금융",
		orgName: "쿠콘",
		orgCode: "E1AAKF0000",
		industry: "efin",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "현대커머셜주식회사",
		orgCode: "D3AAOA0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "주식회사 우리카드",
		orgCode: "D1AAAH0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "한화생명보험 (주)",
		orgCode: "B1AAQI0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "에이비엘생명보험(주)",
		orgCode: "B1AAFP0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "미래에셋생명보험(주)",
		orgCode: "A1AAHE0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "미래에셋생명(주)",
		orgCode: "B1AAHE0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "주식회사 카카오뱅크",
		orgCode: "A1AAHJ0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "전자금융",
		orgName: "주식회사 카카오뱅크",
		orgCode: "E1AAHJ0000",
		industry: "efin",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "미래에셋캐피탈(주)",
		orgCode: "D3AAHO0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "(주)대구은행",
		orgCode: "D1AAHS0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "캐롯손해보험(주)",
		orgCode: "B2AAIF0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "부산은행",
		orgCode: "D1AAII0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "디지비생명보험주식회사",
		orgCode: "B1AANL0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "주식회사 경남은행",
		orgCode: "D1AAIM0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "한국투자증권",
		orgCode: "C1AACT0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "KB손해보험",
		orgCode: "B2AALR0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "통신",
		orgName: "KB국민은행",
		orgCode: "F1AAEO0000",
		industry: "telecom",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "삼성카드주식회사",
		orgCode: "D3AAEV0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "푸본현대생명보험주식회사",
		orgCode: "B1AAQA0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "삼성증권",
		orgCode: "C1AAEY0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "전자금융",
		orgName: "하나카드 주식회사",
		orgCode: "E1AABJ0000",
		industry: "efin",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "현대카드",
		orgCode: "D1AAFO0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "현대해상화재보험",
		orgCode: "B2AAAL0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "키움증권",
		orgCode: "C1AABR0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "현대캐피탈",
		orgCode: "D3AADE0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "교보생명보험(주)",
		orgCode: "B1AAAI0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "-",
		orgName: "나이스평가정보",
		orgCode: "M1AACW0000",
		industry: "tbdindstr",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "에이아이에이생명보험 주식회사",
		orgCode: "B1AAIX0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "주식회사 우리카드",
		orgCode: "D3AAAH0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "할부금융",
		orgName: "하나카드 주식회사",
		orgCode: "D3AABJ0000",
		industry: "capital",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "카드",
		orgName: "주식회사 카카오뱅크",
		orgCode: "D1AAHJ0000",
		industry: "card",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "전자금융",
		orgName: "KG모빌리언스",
		orgCode: "E1AAPB0000",
		industry: "efin",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "NH투자증권",
		orgCode: "C1AACQ0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "금융투자",
		orgName: "신한금융투자(주)",
		orgCode: "C1AADF0000",
		industry: "invest",
		broadcasting: "-",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "은행",
		orgName: "농업협동조합중앙회",
		orgCode: "A4AAAZ0000",
		industry: "bank",
		broadcasting: "-",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - API자체구축",
		industryType: "보험",
		orgName: "KDB생명보험(주)",
		orgCode: "B1AAMU0000",
		industry: "insu",
		broadcasting: "-",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 미디어로그",
		orgCode: "F1AACK0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "신용협동조합중앙회",
		orgCode: "A4AAKM0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "신용협동조합중앙회",
		orgCode: "D1AAKM0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "AXA손해보험주식회사",
		orgCode: "B2AACL0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(유)유니버셜대부",
		orgCode: "G1AAOE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "스타파이낸셜서비시스",
		orgCode: "D3AACM0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "푸른저축은행",
		orgCode: "A3AAKL0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "한국증권금융",
		orgCode: "C1AACO0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "교보증권",
		orgCode: "C1AACS0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "(주)상상인증권",
		orgCode: "C1AACV0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "한양증권",
		orgCode: "C1AACX0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "상상인저축은행",
		orgCode: "A3AALD0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "안국저축은행",
		orgCode: "A3AALE0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "아름방송네트워크",
		orgCode: "F1AAOJ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "제이티저축은행",
		orgCode: "A3AALF0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사경인대부",
		orgCode: "G1AAEB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "영진저축은행",
		orgCode: "A3AALG0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "키움저축은행",
		orgCode: "A3AANX0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한화저축은행",
		orgCode: "A3AALH0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "씨앤에이치캐피탈(주)",
		orgCode: "D3AAEC0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "인천저축은행",
		orgCode: "A3AALI0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "모아저축은행",
		orgCode: "A3AALK0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "인성저축은행",
		orgCode: "A3AALL0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "남인천방송",
		orgCode: "F1AAOL0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "남양저축은행",
		orgCode: "A3AALM0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 케이티엠모바일",
		orgCode: "F1AAED0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "한화솔루션(주) 갤러리아부문",
		orgCode: "D2AAOD0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 유니컴즈",
		orgCode: "F1AAEE0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "롯데오토리스 주식회사",
		orgCode: "D3AAEF0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "대한와이디대부",
		orgCode: "G1AAEG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(유)이코플러스대부",
		orgCode: "G1AAEH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 에이프러스",
		orgCode: "F1AAEI0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "웰릭스캐피탈",
		orgCode: "D3AAJO0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 어니스트펀드",
		orgCode: "L1AAEL0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "조은저축은행",
		orgCode: "A3AALP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "민국저축은행",
		orgCode: "A3AALQ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "에이캐피탈",
		orgCode: "D3AAEP0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "㈜조은리츠대부금융",
		orgCode: "G1AAEJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "DB생명보험주식회사",
		orgCode: "B1AAET0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "산은캐피탈주식회사",
		orgCode: "D3AAEZ0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "디비캐피탈 주식회사",
		orgCode: "D3AAFA0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "브이아이금융투자 주식회사",
		orgCode: "C1AAFB0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "비케이자산관리대부",
		orgCode: "G1AAPE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "태강대부",
		orgCode: "G1AAFC0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "엠메이드대부 유한회사",
		orgCode: "G1AAFD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "더원플랫폼",
		orgCode: "F1AAFF0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "한국선불카드 주식회사",
		orgCode: "E1AAOF0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "에스원",
		orgCode: "F1AAOH0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "신영자산관리대부(유)",
		orgCode: "G1AAJK0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 바로크레디트대부",
		orgCode: "G1AAFH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 한빛자산관리대부",
		orgCode: "G1AAFI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "스카이저축은행",
		orgCode: "A3AALU0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "비엠더블유파이낸셜서비스코리아",
		orgCode: "D3AAJX0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)미니게이트",
		orgCode: "F1AAFJ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 티몬",
		orgCode: "E1AAFK0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "(주)에코캐피탈",
		orgCode: "D3AAFL0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "이든에셋대부 유한회사",
		orgCode: "G1AAFM0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "코나아이 (주)",
		orgCode: "E1AABZ0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "구글페이먼트코리아",
		orgCode: "E1AAPU0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)오케이저축은행",
		orgCode: "A3AALX0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "파인디지털",
		orgCode: "F1AAFN0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "유안타저축은행(주)",
		orgCode: "A3AALY0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "리드코프 (주)",
		orgCode: "G1AAFR0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "대신저축은행",
		orgCode: "A3AALW0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "씨앤에스링크",
		orgCode: "F1AAOQ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)하트캐싱대부",
		orgCode: "G1AAMA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "앤알캐피탈대부(주)",
		orgCode: "G1AAFV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 씨씨콜렉션대부",
		orgCode: "G1AAMB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "(주)애큐온캐피탈",
		orgCode: "D3AAFW0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "ES파이낸셜",
		orgCode: "D3AAFX0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)프리텔레콤",
		orgCode: "F1AAFZ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "KB저축은행",
		orgCode: "A3AAMC0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주) 벤투라인베스트먼트대부",
		orgCode: "G1AAMD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "산림조합중앙회",
		orgCode: "A4AAGC0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "산림조합중앙회",
		orgCode: "D1AAGC0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "키움예스저축은행",
		orgCode: "A3AAME0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "나이스정보통신㈜",
		orgCode: "E1AAGF0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 카길애그리퓨리나",
		orgCode: "G1AAGG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "더케이저축은행",
		orgCode: "A3AAMF0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "에스케이커뮤니케이션즈(주)",
		orgCode: "E1AAGH0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "LG유플러스",
		orgCode: "F1AAGI0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "드림라인 주식회사",
		orgCode: "F1AAGJ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주)인터파크",
		orgCode: "E1AAGK0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)신안어소시에이츠대부",
		orgCode: "G1AAGB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 코드모바일",
		orgCode: "F1AAGM0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)앤알커뮤니케이션",
		orgCode: "F1AAGO0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "이베이코리아 유한책임회사",
		orgCode: "E1AAGP0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "인수채권",
		orgName: "한국자산관리공사",
		orgCode: "H1AAOX0000",
		industry: "bond",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "산와대부주식회사",
		orgCode: "G1AAGR0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "액트캐쉬대부",
		orgCode: "G1AAGS0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 오케이인베스트먼트파트너스",
		orgCode: "E1AAGT0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "카카오페이증권",
		orgCode: "C1AAGU0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "인수채권",
		orgName: "(주)국민행복기금",
		orgCode: "H1AAOY0000",
		industry: "bond",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "주식회사 디지비캐피탈",
		orgCode: "D3AAGV0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "에이씨앤코리아",
		orgCode: "F1AAGW0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "제일호더블류홀딩스자산대부",
		orgCode: "G1AAGX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "한국자산캐피탈",
		orgCode: "D3AAMH0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "이오스자산관리제일차대부",
		orgCode: "G1AAGY0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "엠지손해보험주식회사",
		orgCode: "B2AAGZ0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "메르세데스벤츠파이낸셜서비스코리아",
		orgCode: "D3AAPX0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "CK저축은행",
		orgCode: "A3AAMI0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "와이티홀딩스대부 주식회사",
		orgCode: "G1AAHA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(유)디에이치대부금융",
		orgCode: "G1AAOT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "오케이파이낸셜대부",
		orgCode: "G1AAHC0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주)글로벌머니익스프레스",
		orgCode: "E1AAPJ0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 핀크(Finnq inc.)",
		orgCode: "E1AAJI0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "유진투자증권",
		orgCode: "C1AADB0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "에스케이증권주식회사",
		orgCode: "C1AAPW0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "디비금융투자(주)",
		orgCode: "C1AADI0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "LG헬로비전",
		orgCode: "F1AAOG0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 케이티스카이라이프",
		orgCode: "F1AADK0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "유진저축은행",
		orgCode: "A3AAKP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보증보험",
		orgName: "서울보증보험(주)",
		orgCode: "B4AADL0000",
		industry: "ginsu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "처브라이프생명보험 주식회사",
		orgCode: "B1AADM0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "KB라이프생명",
		orgCode: "B1AAJM0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주)카카오",
		orgCode: "E1AAPC0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "인수채권",
		orgName: "케이알앤씨",
		orgCode: "H1AAOZ0000",
		industry: "bond",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 딜라이브",
		orgCode: "F1AAJP0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)에이원대부캐피탈",
		orgCode: "G1AADQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "에넥스텔레콤",
		orgCode: "F1AADR0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "오릭스캐피탈코리아 주식회사",
		orgCode: "D3AADS0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)한국케이블텔레콤",
		orgCode: "F1AADT0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 동그라미파이낸스대부",
		orgCode: "G1AADU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 제이피인베스트먼트대부",
		orgCode: "G1AAJJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "제이티친애저축은행",
		orgCode: "A3AAKS0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "비바리퍼블리카",
		orgCode: "E1AADV0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 디셈버앤컴퍼니자산운용",
		orgCode: "E1AADW0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 어드벤스대부",
		orgCode: "G1AADX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사와이드모바일",
		orgCode: "F1AADY0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "금화저축은행",
		orgCode: "A3AAKW0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "페퍼저축은행",
		orgCode: "A3AAKX0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "안양저축은행",
		orgCode: "A3AAKY0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "부림저축은행",
		orgCode: "A3AAKZ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "삼정저축은행",
		orgCode: "A3AALB0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "세람저축은행",
		orgCode: "A3AALC0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "세틀뱅크주식회사",
		orgCode: "E1AAAC0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "KB생명보험",
		orgCode: "B1AANZ0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "웨이브파트너스대부 ㈜",
		orgCode: "G1AAAE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "에이아이지손해보험",
		orgCode: "B2AAAG0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "오케이캐피탈(주)",
		orgCode: "D3AAAJ0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "디비저축은행",
		orgCode: "A3AAJY0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)큰사람 커넥트",
		orgCode: "F1AAAM0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "KT",
		orgCode: "F1AAAN0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "중국은행 주식회사 서울지점",
		orgCode: "D1AAKC0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "삼성선물",
		orgCode: "C1AAAP0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "유진투자선물",
		orgCode: "C1AAAQ0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "에스케이텔레콤주식회사",
		orgCode: "F1AAAU0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "에스케이텔링크주식회사",
		orgCode: "F1AAAV0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "비엔피파리바카디프생명보험",
		orgCode: "B1AAKD0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "알씨아이파이낸셜서비스코리아 주식회사",
		orgCode: "D3AAAW0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 티머니",
		orgCode: "E1AAAX0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "라이나생명보험",
		orgCode: "B1AAAY0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한국주택금융공사",
		orgCode: "A1AAOU0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "중국은행 주식회사 서울지점",
		orgCode: "A2AAKC0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한국장학재단",
		orgCode: "A1AAOV0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "무림캐피탈 주식회사",
		orgCode: "D3AABA0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "IBK연금보험(주)",
		orgCode: "B1AABD0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "한국에셋채권대부 주식회사",
		orgCode: "G1AABM0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 뱅크샐러드",
		orgCode: "E1AABN0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)위너스텔",
		orgCode: "F1AABO0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)예가람저축은행",
		orgCode: "A3AAKE0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "IBK투자증권",
		orgCode: "C1AABU0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유미캐피탈대부 주식회사",
		orgCode: "G1AABX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "MCI대부(주)",
		orgCode: "G1AAKG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "한국투자캐피탈",
		orgCode: "D3AABY0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)유노스프레스티지대부",
		orgCode: "G1AACB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "테크메이트코리아대부 주식회사",
		orgCode: "G1AACD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)인더스코대부",
		orgCode: "G1AACE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "옐로우캐피탈대부",
		orgCode: "G1AAKH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "메리츠캐피탈 주식회사",
		orgCode: "D3AABW0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주) 핀샷",
		orgCode: "E1AACF0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주) 핀샷",
		orgCode: "F1AACF0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "웰컴크레디라인대부(주)",
		orgCode: "G1AACG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "한울대부자산관리 주식회사",
		orgCode: "G1AAPI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "한국피엠오",
		orgCode: "F1AAJS0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유원캐피탈대부㈜",
		orgCode: "G1AACI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "OSB저축은행",
		orgCode: "A3AAKJ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "-",
		orgName: "에스씨아이평가정보㈜",
		orgCode: "M1AACJ0000",
		industry: "tbdindstr",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)ES저축은행",
		orgCode: "A3AAKK0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "케이디디아이코리아",
		orgCode: "F1AAAB0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "서민금융진흥원",
		orgCode: "A1AAOW0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "오성저축은행",
		orgCode: "A3AAPT0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "에스케이플래닛(주)",
		orgCode: "E1AABE0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "고려저축은행",
		orgCode: "A3AANK0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "오션펀딩",
		orgCode: "L1AATA0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "코리아에셋투자증권",
		orgCode: "C1AADP0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 한신에셋대부",
		orgCode: "G1AATF0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "준오에셋대부 유한회사",
		orgCode: "G1AAQW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)두루드림대부",
		orgCode: "G1AAKV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유앤아이대부 유한회사",
		orgCode: "G1AARI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "비에프펀드",
		orgCode: "L1AASL0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "케이뱅크은행",
		orgCode: "A1AAJB0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "디에스투자증권",
		orgCode: "C1AAJG0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "주식회사 드림저축은행",
		orgCode: "D1AANG0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "바로저축은행",
		orgCode: "A3AALZ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주)에잇퍼센트",
		orgCode: "L1AATL0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 프로핏",
		orgCode: "L1AASM0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)융창저축은행",
		orgCode: "D1AALN0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "피플펀드컴퍼니",
		orgCode: "L1AASN0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "대부원 유한회사",
		orgCode: "G1AAQQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "새마을금고중앙회",
		orgCode: "D1AAPA0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "엠캐피탈(주)",
		orgCode: "D3AABL0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주)에이치엔씨핀테크",
		orgCode: "L1AATD0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "인도네시아느가라은행 서울지점",
		orgCode: "A2AARG0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "와이앤케이파트너스대부(주)",
		orgCode: "G1AAUS0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "신한캐피탈 주식회사",
		orgCode: "D3AAWG0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "금화저축은행",
		orgCode: "D1AAKW0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 엠에이치파이낸스대부",
		orgCode: "G1AAUR0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 엠에이피대부",
		orgCode: "G1AARJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "롯데멤버스주식회사",
		orgCode: "E1AABK0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "코나아이(주)",
		orgCode: "F1AABZ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "신용회복위원회",
		orgCode: "A1AASY0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 윙크스톤파트너스",
		orgCode: "L1AAVF0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "인수채권",
		orgName: "한국장학재단",
		orgCode: "H1AAOV0000",
		industry: "bond",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "한별에셋대부 주식회사",
		orgCode: "G1AATC0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "한국산업은행",
		orgCode: "D1AAAD0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "대백저축은행",
		orgCode: "A3AANB0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "알에스아이대부(주)",
		orgCode: "G1AAPZ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "한화자산운용(주)",
		orgCode: "C1AAQL0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "키움예스저축은행",
		orgCode: "D1AAME0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "더케이저축은행",
		orgCode: "D1AAMF0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)아이엠에셋대부",
		orgCode: "G1AARY0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "-",
		orgName: "주식회사 비드펀딩",
		orgCode: "",
		industry: "tbdindstr",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 베리타스자산대부",
		orgCode: "G1AAGA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 현대베리타스투자4호대부",
		orgCode: "G1AATQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "메리츠자산운용",
		orgCode: "C1AARV0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "아이엔씨홀딩스대부(주)",
		orgCode: "G1AATG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주) 다온핀테크",
		orgCode: "L1AATZ0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)에스앤티저축은행",
		orgCode: "D1AANO0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "엔에이치저축은행",
		orgCode: "A3AAKR0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 골든캐피탈대부",
		orgCode: "G1AARK0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 보스그룹",
		orgCode: "F1AAIG0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "나라대부금융 주식회사",
		orgCode: "G1AARL0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 뉴아리원대부",
		orgCode: "G1AATP0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 안전대부",
		orgCode: "G1AAUK0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "케이티비투자증권(주)",
		orgCode: "C1AAPV0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)저스트인타임대부",
		orgCode: "G1AATE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)콜렉트대부",
		orgCode: "G1AAQY0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "하나저축은행",
		orgCode: "A3AAKB0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)비젼에셋대부",
		orgCode: "G1AASD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "오투저축은행",
		orgCode: "A3AAMP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)미래크레디트대부",
		orgCode: "G1AAKQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "새마을금고중앙회",
		orgCode: "A4AAPA0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 머천드코리아",
		orgCode: "F1AABP0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "티에이자산관리대부",
		orgCode: "G1AATW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)채권추심전문엘씨대부",
		orgCode: "G1AATM0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "지에이자산관리대부 주식회사",
		orgCode: "G1AATJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "청주저축은행",
		orgCode: "A3AAPO0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한성저축은행",
		orgCode: "A3AAPP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "우리금융저축은행",
		orgCode: "A3AAMK0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 씨씨에스충북방송",
		orgCode: "F1AAHD0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "대명저축은행",
		orgCode: "A3AAPQ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)씨엠비",
		orgCode: "F1AAHF0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "우리금융캐피탈",
		orgCode: "D3AAMM0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "한국캐피탈(주)",
		orgCode: "D3AAHG0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "주식회사 케이카캐피탈",
		orgCode: "D3AAHH0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "엠에스아이대부",
		orgCode: "G1AAHI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "삼호저축은행",
		orgCode: "A3AAMQ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "금강방송주식회사",
		orgCode: "F1AAHL0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)광주은행",
		orgCode: "A1AAMW0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "더블저축은행",
		orgCode: "A3AAMT0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)광주은행",
		orgCode: "D1AAMW0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "대한저축은행",
		orgCode: "A3AAMX0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)한국케이블TV 광주방송",
		orgCode: "F1AAHN0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)한국투자저축은행",
		orgCode: "A3AAMY0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "스타저축은행",
		orgCode: "A3AAMZ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)전북은행",
		orgCode: "A1AAHP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)전북은행",
		orgCode: "D1AAHP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "엠에스저축은행",
		orgCode: "A3AANA0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "제이비우리캐피탈",
		orgCode: "D3AAHR0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)대구은행",
		orgCode: "A1AAHS0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "디지비유페이",
		orgCode: "E1AAPY0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "한국케이블티브이푸른방송(주)",
		orgCode: "F1AAHT0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "인케어파트너스대부",
		orgCode: "G1AAHU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "유니온저축은행",
		orgCode: "A3AANC0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "대원저축은행",
		orgCode: "A3AAPR0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "머스트삼일저축은행",
		orgCode: "A3AANE0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "드림저축은행",
		orgCode: "A3AANG0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "에스와이오토캐피탈",
		orgCode: "D3AAHV0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "라온저축은행",
		orgCode: "A3AANH0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "수협은행",
		orgCode: "D1AAHX0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "수협은행",
		orgCode: "A1AAHX0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "대아저축은행",
		orgCode: "A3AAND0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "네이버파이낸셜 주식회사",
		orgCode: "E1AAHY0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "웰컴페이먼츠",
		orgCode: "E1AAHZ0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 카카오페이",
		orgCode: "E1AAIA0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 현대에이치씨엔",
		orgCode: "F1AAIC0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "이엘자산관리대부 유한회사",
		orgCode: "G1AAID0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "엔에이치엔페이코 주식회사",
		orgCode: "E1AAIE0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 인스코비",
		orgCode: "F1AAIH0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)흥국저축은행",
		orgCode: "A3AANI0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "국제저축은행",
		orgCode: "A3AANJ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "부산은행",
		orgCode: "A1AAII0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "(주) 비엔케이투자증권",
		orgCode: "C1AAIK0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "우리저축은행",
		orgCode: "A3AANM0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "디에이치저축은행",
		orgCode: "A3AANN0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "아이즈비전",
		orgCode: "F1AAOI0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)에스앤티저축은행",
		orgCode: "A3AANO0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "주식회사 경남은행",
		orgCode: "A1AAIM0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "주식회사 경남은행",
		orgCode: "D3AAIM0000",
		industry: "capital",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "제이씨엔울산중앙방송 주식회사",
		orgCode: "F1AAIN0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "IBK저축은행",
		orgCode: "A3AANP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "조흥저축은행",
		orgCode: "A3AANQ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "진주저축은행",
		orgCode: "A3AANR0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)서경방송",
		orgCode: "F1AAIO0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "솔브레인저축은행",
		orgCode: "A3AANS0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "주식회사 제주은행",
		orgCode: "A1AAIP0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)KCTV제주방송",
		orgCode: "F1AAOK0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "㈜ 센트비(SENTBE)",
		orgCode: "E1AAIQ0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "동원제일저축은행",
		orgCode: "A3AANT0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "포도송이자산관리배부 주식회사",
		orgCode: "G1AAIS0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "블루월넛 주식회사",
		orgCode: "E1AAIU0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "비에스아이대부",
		orgCode: "G1AAIT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주)트래블월렛",
		orgCode: "E1AAIV0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)베이콘",
		orgCode: "F1AAIW0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 굿모닝자산관리대부",
		orgCode: "G1AANU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "한패스",
		orgCode: "E1AAPK0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 테라윈자산대부",
		orgCode: "G1AANV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 스테이지파이브",
		orgCode: "F1AAIZ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "11번가(주)",
		orgCode: "E1AAJA0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "키움캐피탈",
		orgCode: "D3AAJC0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "SSG닷컴",
		orgCode: "E1AAPM0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 조이텔",
		orgCode: "F1AAJD0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "하나캐피탈 주식회사",
		orgCode: "D3AAGE0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "제니스자산관리대부",
		orgCode: "G1AABH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "리딩투자증권 주식회사",
		orgCode: "C1AAQF0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한국산업은행",
		orgCode: "A1AAAD0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한국씨티은행",
		orgCode: "A1AAQE0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "토요타파이낸셜서비스코리아(주)",
		orgCode: "D3AAQJ0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)강남캐피탈대부",
		orgCode: "G1AARZ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "주식회사 현대백화점",
		orgCode: "D2AAPG0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "더키움자산관리대부 주식회사",
		orgCode: "G1AAQP0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "유안타저축은행(주)",
		orgCode: "D1AALY0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 애플투자대부",
		orgCode: "G1AAQX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "도담자산관리대부(주)",
		orgCode: "G1AASB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "도이치파이낸셜 주식회사",
		orgCode: "D3AAHB0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)니즈텔레콤",
		orgCode: "F1AAJR0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)씨엔커뮤니케이션",
		orgCode: "F1AAOM0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)한국투자저축은행",
		orgCode: "D1AAMY0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "교보라이프플래닛생명보험(주)",
		orgCode: "B1AAJH0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "영일자산관리대부 유한회사",
		orgCode: "G1AASO0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "비엔케이캐피탈(주)",
		orgCode: "D3AAIL0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "하나손해보험",
		orgCode: "B2AABT0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 평구파이낸스대부",
		orgCode: "G1AARM0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "비엔피파리바카디프손해보험 주식회사",
		orgCode: "B2AAQG0000",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "SK브로드밴드",
		orgCode: "F1AAFT0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)바리움홀딩스대부",
		orgCode: "G1AASA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "진성자산관리대부 주식회사",
		orgCode: "G1AARN0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)넥스젠파이낸스대부",
		orgCode: "G1AAQU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "리딩플러스",
		orgCode: "L1AASC0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유한회사 칸에셋대부",
		orgCode: "G1AASG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)레그원",
		orgCode: "F1AAOO0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 오누리인터내셔날대부",
		orgCode: "G1AARW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "키움저축은행",
		orgCode: "D1AANX0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "수산업협동조합중앙회",
		orgCode: "A4AAGD0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "엔티온텔레콤 주식회사",
		orgCode: "F1AAOR0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)센트럴저축은행",
		orgCode: "A3AAMS0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유한회사 우담자산관리대부",
		orgCode: "G1AARO0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 신현대부실자산관리",
		orgCode: "G1AASH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 대한채권관리대부",
		orgCode: "G1AANW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한국수출입은행",
		orgCode: "A1AARE0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주)와이펀드",
		orgCode: "L1AARS0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)엔페이넷",
		orgCode: "F1AARF0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "롯데캐피탈 주식회사",
		orgCode: "D3AAQO0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "-",
		orgName: "(주)아이브이에셋대부",
		orgCode: "",
		industry: "tbdindstr",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "중국공상은행",
		orgCode: "A2AALS0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "쿠팡페이",
		orgCode: "E1AAPN0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "아프로파이낸셜대부(주)",
		orgCode: "G1AAGN0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 비컴콜렉션대부",
		orgCode: "G1AARP0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "흥국증권 주식회사",
		orgCode: "C1AABS0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "오성저축은행",
		orgCode: "D1AAPT0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)나이스대부",
		orgCode: "G1AAQV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "대복에이엠씨대부(주)",
		orgCode: "G1AASE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(유)테라에셋대부",
		orgCode: "G1AASU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "브이핀테크",
		orgCode: "L1AARU0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주)위펀딩",
		orgCode: "L1AASI0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 투게더앱스",
		orgCode: "L1AASW0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "애니원캐피탈대부(주)",
		orgCode: "G1AAGQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "주식회사 대아상호저축은행",
		orgCode: "D1AAND0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "그린씨엔에스자산관리대부",
		orgCode: "G1AAUD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)엠에스저축은행",
		orgCode: "D1AANA0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)아이비케이저축은행",
		orgCode: "D1AANP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "부국증권",
		orgCode: "C1AAJN0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "한국씨티은행",
		orgCode: "D1AAQE0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "이더블유자산관리대부 유한회사",
		orgCode: "G1AATT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)씨엔에스대부",
		orgCode: "G1AAQZ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "한국농수산식품유통공사",
		orgCode: "A1AARC0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 레드로켓",
		orgCode: "L1AASV0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 나모펀딩",
		orgCode: "L1AATO0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "볼보파이낸셜서비스코리아 주식회사",
		orgCode: "D3AAEK0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "엠브릿지대부유한회사",
		orgCode: "G1AAUA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 데일리펀딩",
		orgCode: "L1AAVS0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "삼성자산운용(주)",
		orgCode: "C1AAQC0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "애큐온저축은행",
		orgCode: "A3AALT0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "엔에이치선물 주식회사",
		orgCode: "C1AARA0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "외환베리타스제2차대부 유한회사",
		orgCode: "G1AAJW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 현대베리타스투자1호대부",
		orgCode: "G1AAJV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)인스코리아",
		orgCode: "F1AAOS0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "비플러스",
		orgCode: "L1AAST0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사한국채권관리대부",
		orgCode: "G1AASX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)국민채권관리대부",
		orgCode: "G1AAFG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "제이티대부 주식회사",
		orgCode: "G1AATH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "프라임자산관리대부(주)",
		orgCode: "G1AATI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 아이엔비자산관리대부",
		orgCode: "G1AAUH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 로제캐피탈대부",
		orgCode: "G1AAUM0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "와이엘랜드",
		orgCode: "F1AABB0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "우리종합금융 주식회사",
		orgCode: "C1AAPD0000",
		industry: "invest",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 베델자산관리대부",
		orgCode: "G1AAQS0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "제이티친애저축은행",
		orgCode: "D1AAKS0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주)한페이시스",
		orgCode: "",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 펀딩119",
		orgCode: "L1AATR0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "선한자산관리대부주식회사",
		orgCode: "G1AARB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "유화증권",
		orgCode: "C1AACN0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "에이치엠자산관리대부(주)",
		orgCode: "G1AASS0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "해밀자산관리대부유한회사",
		orgCode: "G1AAVD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "토스뱅크 주식회사",
		orgCode: "A1AAPF0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)동양저축은행",
		orgCode: "A3AAMV0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "주식회사 대명상호저축은행",
		orgCode: "D1AAPQ0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "스마텔",
		orgCode: "F1AAGL0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)융창저축은행",
		orgCode: "A3AALN0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)페어컬렉션대부",
		orgCode: "G1AATK0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "해진에셋대부유한회사",
		orgCode: "G1AAUT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 파란에셋대부",
		orgCode: "G1AAUP0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "씨엠피자산관리대부 주식회사",
		orgCode: "G1AAUQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "상상인플러스저축은행",
		orgCode: "A3AAMN0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "주식회사 제이엠캐피탈",
		orgCode: "",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "비케이에셋대부(주)",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)그로우잉대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "제이에셋대부주식회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "동양자산관리대부 주식회사",
		orgCode: "G1AAUY0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "세람저축은행",
		orgCode: "D1AALC0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)피엔케이에이엠씨대부",
		orgCode: "G1AASQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "스마트저축은행",
		orgCode: "A3AAMR0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "진주저축은행",
		orgCode: "D1AANR0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "평택상호저축은행",
		orgCode: "A3AALA0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "희망1자산대부관리 유한회사",
		orgCode: "G1AAUN0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 비앤엠에셋대부",
		orgCode: "G1AATY0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "아이앤유크레디트대부(주)",
		orgCode: "G1AAUF0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 히어로비케이대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "케이앤에스에이엠씨대부 주식회사",
		orgCode: "G1AAUZ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)듀오캐피탈대부",
		orgCode: "G1AAVA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "디에스엔피엘인베스트먼트대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "웰릭스에프앤아이대부(주)",
		orgCode: "G1AACH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)에스비아이저축은행",
		orgCode: "D1AAJZ0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "라온저축은행",
		orgCode: "D1AANH0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "폭스바겐파이낸셜서비스코리아",
		orgCode: "D3AABC0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 인에이블자산대부",
		orgCode: "G1AARD0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "씨앤알대부유한회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유니애대부 유한회사",
		orgCode: "G1AAFE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "동부에셋자산관리대부",
		orgCode: "G1AAUJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "신성자산대부관리 유한회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "에이원자산대부관리 유한회사",
		orgCode: "G1AAVB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "로카모빌리티 주식회사",
		orgCode: "E1AAWD0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "토스뱅크 주식회사",
		orgCode: "D1AAPF0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)더블저축은행",
		orgCode: "D1AAMT0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)대백저축은행",
		orgCode: "D1AANB0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "한국포스증권",
		orgCode: "C1AAQD0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "인수채권",
		orgName: "농업협동조합자산관리회사",
		orgCode: "H1AAPL0000",
		industry: "bond",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "우아한형제들",
		orgCode: "E1AAQK0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "케이뱅크은행",
		orgCode: "D1AAJB0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "브라보캐피탈앤드대부주식회사",
		orgCode: "G1AAQR0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 퀀텀자산관리대부",
		orgCode: "G1AAVR0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 론포인트",
		orgCode: "L1AARX0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "스마트저축은행",
		orgCode: "D1AAMR0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "상호저축은행중앙회",
		orgCode: "A3AAPH0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "유진저축은행",
		orgCode: "D1AAKP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "상호저축은행중앙회",
		orgCode: "D1AAPH0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "민국저축은행",
		orgCode: "D1AALQ0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "조은저축은행",
		orgCode: "D1AALP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "세종텔레콤 주식회사",
		orgCode: "F1AAJQ0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "엔에이치저축은행",
		orgCode: "D1AAKR0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "주식회사 제주은행",
		orgCode: "D1AAIP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 해방새대부",
		orgCode: "G1AATS0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사제이에스앤대부",
		orgCode: "G1AAUI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "아이씨엘대부 주식회사",
		orgCode: "G1AAUB0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "KB저축은행",
		orgCode: "D1AAMC0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 한일에셋대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 에이블자산관리대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)머스트삼일저축은행",
		orgCode: "D1AANE0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "부림저축은행",
		orgCode: "D1AAKZ0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "페퍼저축은행",
		orgCode: "D1AAKX0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)센트럴저축은행",
		orgCode: "D1AAMS0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "상상인플러스저축은행",
		orgCode: "D1AAMN0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "휴엘컴퍼니",
		orgCode: "F1AAON0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "(주)씨케이커뮤스트리",
		orgCode: "F1AASF0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "하이투자증권(주)",
		orgCode: "C1AAIJ0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "유에셋대부(주)",
		orgCode: "G1AATV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "오아시스펀딩",
		orgCode: "L1AAVC0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "가교에이엠씨대부(주)",
		orgCode: "G1AAVG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "부산하나로카드 주식회사",
		orgCode: "E1AAWC0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "비콜렉트대부 주식회사",
		orgCode: "G1AAMJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "인스자산관리대부(주)",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "한성저축은행",
		orgCode: "D1AAPP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "주)우리금융저축은행",
		orgCode: "D1AAMK0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)오투저축은행",
		orgCode: "D1AAMP0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "롯데쇼핑(주)e커머스사업본부",
		orgCode: "E1AAVE0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 렌딧",
		orgCode: "L1AAQM0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "홍콩상하이은행",
		orgCode: "A2AARH0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주)헬로핀테크",
		orgCode: "L1AARR0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "진영자산관리대부(주)",
		orgCode: "G1AASJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)그린씨앤에프대부",
		orgCode: "G1AATU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)레드에프앤아이대부",
		orgCode: "G1AASR0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "보험",
		orgName: "하나생명보험",
		orgCode: "",
		industry: "insu",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "대산대부주식회사",
		orgCode: "G1AATN0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "더에이치자산관리대부 주식회사",
		orgCode: "G1AAUO0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 임프루브대부",
		orgCode: "G1AAQT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "할부금융",
		orgName: "메이슨캐피탈(주)",
		orgCode: "D3AAHK0000",
		industry: "capital",
		broadcasting: "한국신용정보원",
		baseBroadcasting: "한국신용정보원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "엘하비스트 대부",
		orgCode: "G1AATX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "지엔피엘대부 주식회사",
		orgCode: "G1AAUU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "빅엔파트너스대부 주식회사",
		orgCode: "G1AAUC0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "예스자산대부",
		orgCode: "G1AABI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사태영에이엠씨대부",
		orgCode: "G1AAUG0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사엘이대부",
		orgCode: "G1AAUE0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "(주)위메프",
		orgCode: "E1AAWB0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "이스트자산관리대부",
		orgCode: "G1AAUW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)시소캐피탈대부",
		orgCode: "G1AAJT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)청주저축은행",
		orgCode: "D1AAPO0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "CK저축은행",
		orgCode: "D1AAMI0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)대한저축은행",
		orgCode: "D1AAMX0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "아이디스파워텔 주식회사",
		orgCode: "F1AADG0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "(주)펀다",
		orgCode: "",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "에스엠에이엠씨투자대부(주)",
		orgCode: "G1AASZ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "에스앤아이캐피탈대부 주식회사",
		orgCode: "G1AAUV0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "솔림헬프자산관리대부",
		orgCode: "G1AAVT0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "대성인베스트자산관리대부(주)",
		orgCode: "G1AAUL0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "전자금융",
		orgName: "주식회사 마이비",
		orgCode: "E1AAWE0000",
		industry: "efin",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "한국자산대부주식회사",
		orgCode: "G1AAWJ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "인성저축은행",
		orgCode: "D1AALL0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)스카이저축은행",
		orgCode: "D1AALU0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "외환베리타스제1차대부 유한회사",
		orgCode: "G1AAWA0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "모아저축은행",
		orgCode: "D1AALK0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "케이프투자증권",
		orgCode: "C1AABV0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)에스비아이저축은행",
		orgCode: "A3AAJZ0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 신의자산관리대부",
		orgCode: "G1AARQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "참저축은행",
		orgCode: "A3AANF0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "주식회사 줌펀드",
		orgCode: "L1AAVI0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "오케이에프앤아이대부",
		orgCode: "G1AAFU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "캐시트리대부",
		orgCode: "G1AAUX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)인천저축은행",
		orgCode: "D1AALI0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "솔브레인저축은행",
		orgCode: "D1AANS0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "스타저축은행",
		orgCode: "D1AAMZ0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "조흥저축은행",
		orgCode: "D1AANQ0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "평택상호저축은행",
		orgCode: "D1AALA0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "금융투자",
		orgName: "토스증권 주식회사",
		orgCode: "C1AAHW0000",
		industry: "invest",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "신한저축은행",
		orgCode: "A3AAKT0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)엔씨파이낸스대부",
		orgCode: "G1AASK0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "-"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "BNK저축은행",
		orgCode: "A3AAPS0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 한국니치대부금융",
		orgCode: "G1AART0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "에이파이브자산대부관리 유한회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "씨에이치에셋대부(유)",
		orgCode: "G1AAVH0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "삼정저축은행",
		orgCode: "D1AALB0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "통신",
		orgName: "주식회사 원텔레콤",
		orgCode: "F1AAOP0000",
		industry: "telecom",
		broadcasting: "한국정보통신진흥협회",
		baseBroadcasting: "한국정보통신진흥협회"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "(주)안양저축은행",
		orgCode: "D1AAKY0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "모두캐피탈대부 주식회사",
		orgCode: "G1AAVU0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 티웨일자산관리대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 모두론대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "헤럴드자산관리대부 주식회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)스타크레디트대부",
		orgCode: "G1AAVQ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)러키캐피탈대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 티플레인대부",
		orgCode: "G1AAVY0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "P2P",
		orgName: "미라클핀테크",
		orgCode: "L1AAVV0000",
		industry: "p2p",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)더파이널스대부",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "은행",
		orgName: "(주)국민행복기금",
		orgCode: "A1AAOY0000",
		industry: "bank",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)케이아이코아즈대부",
		orgCode: "G1AAVW0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "반석투자대부 주식회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "카드",
		orgName: "오케이저축은행",
		orgCode: "D1AALX0000",
		industry: "card",
		broadcasting: "금융결제원",
		baseBroadcasting: "금융결제원"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)유아이크레디트대부",
		orgCode: "G1AAVP0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)밀리언캐쉬대부",
		orgCode: "G1AAVZ0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)티포스코퍼레이션대부",
		orgCode: "G1AACC0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "주식회사 유진대부금융",
		orgCode: "G1AAWF0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "(주)프라미스대부",
		orgCode: "G1AAWI0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "씨에프자산관리대부(주)",
		orgCode: "G1AAVX0000",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "정보제공자 - 중계기관이용",
		industryType: "대부",
		orgName: "케이제이자산관리대부 주식회사",
		orgCode: "",
		industry: "usury",
		broadcasting: "코스콤",
		baseBroadcasting: "코스콤"
	},
	{
		orgType: "중계기관",
		industryType: "-",
		orgName: "(주)코스콤",
		orgCode: "ZWAACP0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "중계기관",
		industryType: "-",
		orgName: "사단법인 금융결제원",
		orgCode: "ZWAAEA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "중계기관",
		industryType: "-",
		orgName: "한국신용정보원",
		orgCode: "ZWAAAA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "중계기관",
		industryType: "-",
		orgName: "(사)한국정보통신진흥협회",
		orgCode: "ZWAALV0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(인증서 본인확인기관)",
		industryType: "-",
		orgName: "(주)코스콤",
		orgCode: "ZXAACP0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(인증서 본인확인기관)",
		industryType: "-",
		orgName: "한국정보인증주식회사",
		orgCode: "ZXAACA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(인증서 본인확인기관)",
		industryType: "-",
		orgName: "사단법인 금융결제원",
		orgCode: "ZXAAEA0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(인증서 본인확인기관)",
		industryType: "-",
		orgName: "한국전자인증주식회사",
		orgCode: "ZXAAQB0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(전자서명인증사업자)",
		industryType: "-",
		orgName: "신한은행",
		orgCode: "ZYAAER0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(전자서명인증사업자)",
		industryType: "-",
		orgName: "네이버 주식회사",
		orgCode: "ZYAAQH0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(전자서명인증사업자)",
		industryType: "-",
		orgName: "엔에이치엔페이코 주식회사",
		orgCode: "ZYAAIE0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(전자서명인증사업자)",
		industryType: "-",
		orgName: "비바리퍼블리카",
		orgCode: "ZYAADV0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(전자서명인증사업자)",
		industryType: "-",
		orgName: "(주)국민은행",
		orgCode: "ZYAAEO0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	},
	{
		orgType: "통합인증기관(전자서명인증사업자)",
		industryType: "-",
		orgName: "주식회사 뱅크샐러드",
		orgCode: "ZYAABN0000",
		industry: "-",
		broadcasting: "-",
		baseBroadcasting: "-"
	}
]

export default orgCode